const VARIANTES = {
  primario: "bg-brand-green hover:bg-emerald-900 text-white",
  secundario: "bg-gray-100 hover:bg-gray-200 text-gray-700",
  excel: "bg-green-600 hover:bg-green-700 text-white",
  pdf: "bg-red-600 hover:bg-red-700 text-white",
  imprimir: "bg-gray-600 hover:bg-gray-700 text-white",
  perigo: "bg-red-600 hover:bg-red-700 text-white",
};

/**
 * Botão padrão de ações de relatório (gerar, exportar, imprimir, limpar filtros).
 * `variante` define a cor; o resto do comportamento é do chamador.
 */
const BotaoRelatorio = ({ variante = "primario", carregando, className = "", children, ...props }) => (
  <button
    {...props}
    disabled={carregando || props.disabled}
    className={`font-semibold py-2 px-4 rounded-lg transition duration-200 flex items-center justify-center gap-2 disabled:opacity-60 disabled:cursor-not-allowed ${
      VARIANTES[variante] || VARIANTES.primario
    } ${className}`}
  >
    {carregando ? (
      <>
        <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
        <span>Carregando...</span>
      </>
    ) : (
      children
    )}
  </button>
);

export default BotaoRelatorio;
